export default "__VITE_ASSET__DoW8Ednv__"